import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORY_LABELS, formatPrice } from "../lib/api";

export default function ListingCard({ listing, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/inzerat/${listing.id}`}
        data-testid={`listing-card-${listing.id}`}
        className="group block border border-white/10 bg-[#0d0d0d] hover:border-white/30 transition-colors duration-300"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-[#050505]">
          <img
            src={listing.images?.[0] || "https://images.pexels.com/photos/5965324/pexels-photo-5965324.jpeg"}
            alt={listing.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-black via-black/45 to-transparent pointer-events-none" />
          <div className="absolute top-0 left-0 flex gap-2 p-3">
            <span className="font-head uppercase tracking-[0.15em] text-[10px] font-bold bg-[#ff3b30] text-white px-2.5 py-1">
              {CATEGORY_LABELS[listing.category]}
            </span>
            {listing.condition === "nove" && (
              <span className="font-head uppercase tracking-[0.15em] text-[10px] font-bold bg-white text-black px-2.5 py-1">
                Nové
              </span>
            )}
          </div>
          <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
            <div className="bg-white text-black p-2">
              <ArrowUpRight size={18} />
            </div>
          </div>
        </div>
        <div className="p-5">
          <div className="font-head uppercase tracking-[0.2em] text-[11px] text-[#ff3b30] mb-2">
            {listing.brand}
          </div>
          <h3 className="font-head text-lg font-semibold leading-tight mb-3 group-hover:text-white/90">
            {listing.title}
          </h3>
          <div className="flex items-end justify-between">
            <span className="font-display text-2xl">{formatPrice(listing.price)}</span>
            {listing.size && <span className="text-white/40 text-xs">{listing.size}</span>}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
